(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController(
    $scope,
    ActivateAccountViewModel,
    userActions,
    $state,
    $stateParams,
    $log,
    brand,
    $translate,
    sessionData,
    $location,
    locales,
    dispatcher,
    ActionTypesEnum,
    applicationStore,
    $mdToast,
    $filter,
    checkUserRole,
    helperService
  ) {
    var vm = this;

    vm.account = new ActivateAccountViewModel();
    vm.inputType = 'password';
    vm.inputReType = 'password';

    init();

    vm.resetPassword = function () {
      var code = $stateParams.code;
      var data = {
        password: vm.account.password,
        code: code
      };

      userActions.resetPassword(data).then(function (response) {
        userActions
          .signIn(response.toLowerCase(), vm.account.password)
          .then(function (userInfo) {
            checkUserRole.setCurrentRoles(userInfo.roles);
            helperService.setCurrentUserId(userInfo.user.id);
            helperService.setUserDataToLocalStorageOnLogIn(userInfo, 'en');

            if (checkUserRole.userRoleExist()) {
              $state.go('app.dashboardTechnology');
            } else {
              sessionData.clearAll();
              vm.login.hasErrors = true;
              vm.login.errorMessage = $translate.instant('ERROR_LOGIN_ROLE');
            }
          });
      });
    };

    vm.checkPassword = function (form) {
      var password = form.password.$viewValue;
      var repeatPassword = form.passwordRepeat.$viewValue;

      vm.account.passwordIdentical =
        password === repeatPassword && password !== '' && repeatPassword !== '';
    };

    vm.showPassword = function () {
      vm.inputType = vm.inputType === 'text' ? 'password' : 'text';
    };

    vm.showReenterPassword = function () {
      vm.inputReType = vm.inputReType === 'text' ? 'password' : 'text';
    };

    function init() {
      applicationStore.on(
        applicationStore.events.TOAST_CHANGE,
        showSimpleToast
      );
      var setUserLanguage = $location.search().lang;
      locales.setLanguage(setUserLanguage);
      sessionData.setValue(sessionData.Keys.LANGUAGE_KEY, setUserLanguage);
      vm.welcomeTitle = brand === 'karcher';
      $scope.$on('destroy', function () {});
    }

    function showSimpleToast(data) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent($translate.instant($filter('replacews')(data)))
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }
})();
